/**
 * Whether an answer value should be treated as "not filled in".
 *
 * Note the deliberate special cases: `0` (and `NaN`) are numbers and count as
 * filled, `Date` instances are always filled, and arrays/objects are empty when
 * every element/property is itself empty.
 */
export const isValueEmpty = (value: unknown): boolean => {
  if (typeof value !== "number" && !value) return true;
  if (Array.isArray(value) && value.length === 0) return true;
  if (Array.isArray(value) && value.every(isValueEmpty)) return true;
  if (value instanceof Date) return false;
  if (typeof value === "object" && Object.values(value).every(isValueEmpty)) return true;
  return false;
};
